class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.meteamoAllowMagicUntil = 0;
    this.meteamoBlockMagicUntil = 0;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      if (closeButton.id === 'cart-notification-button') return;
      closeButton.addEventListener('click', this.close.bind(this));
    });

    const viewCart = this.querySelector('#cart-notification-button');
    if (viewCart) {
      viewCart.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.meteamoOpenCartReview();
      });
    }

    this.meteamoWireCartIconAllow();
    this.meteamoSuppressMagicAutoOpen();
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    if (this.header) this.header.reveal();
    // After ATC: show Dawn popup only. Block Magical auto-open briefly.
    this.meteamoBlockMagicUntil = Date.now() + 2500;
    this.meteamoHideMagic();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  meteamoForceClose() {
    this.close();
    if (this.notification) this.notification.classList.remove('active', 'animate');
  }

  meteamoClearMagicInlineHide() {
    document.querySelectorAll('.razorpay-sidecart-container, .razorpay-sidecart-backdrop').forEach((el) => {
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
    });
  }

  meteamoHideMagic() {
    document.body.classList.remove('meteamo-cart-reviewing');
    document.querySelectorAll('.razorpay-sidecart-container, .razorpay-sidecart-backdrop').forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  meteamoIsMagicVisible() {
    const container = document.querySelector('.razorpay-sidecart-container');
    if (!container) return false;
    const style = getComputedStyle(container);
    return style.display !== 'none' && style.visibility !== 'hidden' && container.getBoundingClientRect().width > 40;
  }

  meteamoAllowMagic(ms = 15000) {
    this.meteamoAllowMagicUntil = Date.now() + ms;
    this.meteamoBlockMagicUntil = 0;
    document.body.classList.add('meteamo-cart-reviewing');
    this.meteamoClearMagicInlineHide();
  }

  meteamoWireCartIconAllow() {
    if (window.__meteamoCartIconAllow) return;
    window.__meteamoCartIconAllow = true;
    document.addEventListener(
      'click',
      (event) => {
        const icon = event.target.closest && event.target.closest('#cart-icon-bubble, a.header__icon--cart');
        if (!icon) return;
        // Header cart icon is an intentional open — never keep Magical locked.
        this.meteamoAllowMagic(20000);
        this.meteamoForceClose();
      },
      true
    );
  }

  meteamoOpenCartReview() {
    this.meteamoAllowMagic(20000);
    this.meteamoForceClose();

    const cartLink = document.querySelector('#cart-icon-bubble, a.header__icon--cart');
    if (cartLink) cartLink.click();
    else {
      window.location.assign('/cart');
      return;
    }

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (this.meteamoIsMagicVisible()) {
        clearInterval(timer);
        this.meteamoForceClose();
        return;
      }
      if (tries >= 15) {
        clearInterval(timer);
        window.location.assign('/cart');
      }
    }, 200);
  }

  meteamoSuppressMagicAutoOpen() {
    if (window.__meteamoMagicAtcGuard) return;
    window.__meteamoMagicAtcGuard = true;
    const hideIfAuto = () => {
      // Allowed: View cart / header cart icon window.
      if (Date.now() < (this.meteamoAllowMagicUntil || 0)) return;
      // Only suppress shortly after Add to cart, while Dawn owns the UI.
      if (Date.now() > (this.meteamoBlockMagicUntil || 0)) return;
      if (!this.meteamoIsMagicVisible()) return;
      this.meteamoHideMagic();
    };
    const obs = new MutationObserver(hideIfAuto);
    const start = () => {
      obs.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
      setInterval(hideIfAuto, 400);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
}

customElements.define('cart-notification', CartNotification);
